module.exports = __webpack_public_path__ + "img/73.8.TSS.b5155c70.png";